//created by Peggy on 2021/1/29
import React, { useEffect, useRef, useState, useMemo } from 'react'
import { useHistory, Link, useLocation, useParams } from 'react-router-dom'
import { Divider, Form, Input, Radio, Button, Select, Breadcrumb, message, Tooltip, InputNumber } from 'antd'
import { CheckOutlined, InfoCircleFilled } from '@ant-design/icons'

import styled from 'styled-components'
import ModalInfo from '@/components/Modal/Info'
import { stateList } from '@/types/enum'
import StripePayCom from '@/components/StripePayment'
import { checkSubscribe, getSubscribePrice, subscribePayPal } from '@/api/payment-api'


import icon_donation from '@/images/icons/icon_donation.svg';
import "@/styles/dashboard/mebership.less";
import { ReactComponent as CreditCard } from "@/images/credit_card.svg";
import { getSponsor } from "@/api/merbership-api";
import { consultByStripe, consultOrder, couponCheck } from "@/api/consultation-api";
import { useModel } from "use-reaction";
import { view } from "@/model/view";
import { useThrottledCallback } from "use-debounce/lib";
import { localStorageGet } from '@/utils/storage'
import { TheField } from '@/components/GoogleTranslate'
import { user } from '@/model/user'
const { getData: getCountryList } = require('country-list');
const countryList = getCountryList()

const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
const dayjs = require('dayjs')
dayjs.extend(utc)
dayjs.extend(timezone)

const SummaryContainer = styled.div`
  .hidden {
    display: none;
  }
  .show {
    display: block;
  }
  .flex {
    & > .ant-form-item {
      flex: 1;
      &:first-child {
        margin-right: 24px;
      }
    }
  }
`

const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9;
  .content-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 18px;
    text-transform: uppercase;
    .checkout-logo {
      margin-bottom: 24px;
    }
    span {
      text-decoration: underline;
      display: inline-block;
      margin-right: 24px;
      cursor: pointer;
    }
  }
`

const StripePay = React.forwardRef<any, any>((props, ref) => (
  <StripePayCom {...props} submitRef={ref} />
))

let _page: any = null

const Summary = () => {
  const history = useHistory()
  const { renew } = useParams() as any
  const { renewAnnualNextBillingDate, renewMonthNextBillingDate, expireDate } = (useLocation()
    .state || {}) as any
  const [form] = Form.useForm()
  const [show, setShow] = useState(false)
  const [subsidizedShow, setSubsidizedShow] = useState(false)
  const [allowSubsidized, setAllowSubsidized] = useState(false)
  const [nextBillDate, setNextBillDate] = useState('')
  const submitRef = useRef<any>(null)
  const {store:userStore} = useModel(user)
  const [price, setPrice] = useState<any[]>([])
  const [pay, setPay] = useState<any>({
    payment: 'credit card',
    priceId: '',
    planId: '',
    address: '',
    email: '',
    name: '',
    city: '',
    state: '',
    country: 'US',
    code: ''
  })
  const [payType, setPaytype] = useState(renew ? 'renew' : 'subscribe')
  const [secretId, setSecretId] = useState('')
  const [addon, setAddon] = useState<any>({
    fieldAmount: '',
    contribution: false
  })

  const {
    store: { isMobile }
  } = useModel(view)
  const [selectOption, setSelectOption] = useState<any>()
  useEffect(() => {
    setSelectOption(price.filter((item) => item?.stripePriceId === pay?.priceId)[0])
    // eslint-disable-next-line
  }, [pay.priceId])
  const [amount, setAmount] = useState(0)
  const [promo, setPromo] = useState<any>({
    name: '',
    discount: 0,
    error: false
  })
  const couponValidate = (name: string) => {
    if (!name) {
      setPromo({ name, discount: 0 })
      return false
    }
    couponCheck({
      name,
      productType: 'fiscal_sponsorship',
      price:
        selectOption?.title === "Annual"
          ? selectOption?.totalAmount
          : selectOption?.saleAmount,
    })
      .then((data) => setPromo({ name, discount: data?.discount, error: false }))
      .catch((e) => {
        setPromo({
          name: '',
          discount: 0,
          error: true
        })
      })
  }

  useEffect(() => {
    if (promo?.name) {
      couponValidate(promo?.name)
    }
  }, [selectOption])

  const [submitLoading, setSubmitLoading] = useState(false)
  const submitPay = useThrottledCallback(()=>{
    setSubmitLoading(true)
    if (pay.payment !== "payPal") {
      form.submit();
    } else {
      payPalCharge();
    }
  }, 3000)
  const onFinish = async (values: any) => {
    await setPay({ ...pay, ...values, coupon: promo.name })
    await submitRef?.current?.submit()
  }

  const onFinishFailed = (e: any) => {
    console.log('Failed:', e)
    message.error(e.errorFields[0].errors[0])
  }

  const onPayFailed = ()=>{
    setSubmitLoading(false)
  }
  const onSponsorPaid = async () => {
    if (+addon.fieldAmount > 0) {
      // make add-on donation to thefield
      const fieldAmount = addon.fieldAmount
      setAddon({ fieldAmount: '', contribution: false })
      const order = await consultOrder('fiscal_sponsorship_add_on', { fieldAmount, price: '0' })
      const intent = await consultByStripe({ orderId: order.id })
      setSecretId(intent?.client_secret)
      setPaytype('pay')
      setPay({
        ...pay,
        coupon: ''
      })
      console.log('TEST-onSponsorPaid', pay?.priceId)

      await submitRef?.current?.submit()
    } else {
      setShow(true)
    }
    setSubmitLoading(false)
  }

  useEffect(() => {
    let _data = {
      timezone: dayjs?.tz?.guess()
    }
    getSubscribePrice(_data).then((data) => {
      data?.forEach((item: any) => {
        if (renew) {
          if (item.title === 'Annual') {
            item.description = `Your plan begins on ${dayjs(
              dayjs(expireDate).isBefore(dayjs()) ? undefined : expireDate
            ).format('MMMM DD, YYYY')}
             and will end on ${dayjs(renewAnnualNextBillingDate).format('MMMM DD, YYYY')}.
             We'll send an email reminder 7 days before your membership is scheduled to expire.`
          } else {
            item.description = `Your plan begins on ${dayjs(
              dayjs(expireDate).isBefore(dayjs()) ? undefined : expireDate
            ).format('MMMM DD, YYYY')}
             and your card will be charged on the same day each subsequent month until you cancel this plan.`
          }
        }
        if (allowSubsidized) {
          if (item.title === 'Annual') {
            item.description = `Enjoy your first year free! We are proud to provide you a full discount for your work in Social Justice. Your paid plan will begin on ${dayjs().format(
              'MMMM DD, YYYY'
            )}
             and will end on ${item.nextBillDate}.
             We'll send an email reminder 7 days before the this plan ends.`
          }
        }
      })
      setPrice(data)
    })
  }, [])

  useEffect(() => {
    const userInfo = localStorageGet("info");
    const _pay = {
      ...pay,
      email:userInfo.email,
      country: 'US',
      priceId:
        renew || allowSubsidized
          ? price?.find((_: any) => _.title === 'Annual')?.stripePriceId
          : price[0]?.stripePriceId,
      planId:
        renew || allowSubsidized
          ? price?.find((_: any) => _.title === 'Annual')?.paypalPlanId
          : price[0]?.paypalPlanId
    }
    if (allowSubsidized)
      setNextBillDate(price?.find((_: any) => _.title === 'Annual')?.nextBillDate)
    setPay(_pay)
    form.setFieldsValue(_pay)
  }, [allowSubsidized, price])

  //payPal
  const [payId, setPayId] = useState('')
  const payPalCharge = async () => {
    const _data = await subscribePayPal({
      planId: pay.planId,
      coupon: promo.name
    })
    setPayId(_data.id)
    window.open(
      _data.links[0].href,
      '',
      'height=606,width=400,top=200,left=400,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no'
    )
  }

  const checkPay = () => {
    checkSubscribe({
      id: payId
    }).then((data) => {
      if (data.warning) {
        message.warn(data.warning)
      }
      _page?.close()
      setShow(true)
    })
  }

  // check status
  const [status, setStatus] = useState('')

  const getStatus = () => {
    let _data = {}
    getSponsor(_data).then((data: any) => {
      setSubsidizedShow(data?.allowSubsidized || false)
      setAllowSubsidized(data?.allowSubsidized || false)
      setStatus(data?.status)
    })
  }

  useEffect(() => {
    const price =
      (selectOption?.title === 'Annual'
        ? Math.floor(Number(selectOption?.saleAmount) * 12)
        : selectOption?.saleAmount) - promo?.discount;
    setAmount(+price + parseFloat(addon.fieldAmount || "0"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOption, addon.fieldAmount, promo]);

  useEffect(() => {
    getStatus()
  }, [])

  return (
    <SummaryContainer className="summary-container common-container">
      <Breadcrumb separator=">">
        <Breadcrumb.Item href="/dashboard/membership/fiscal">Fiscal sponsorship</Breadcrumb.Item>
        <Breadcrumb.Item>Fiscal sponsorship payment</Breadcrumb.Item>
      </Breadcrumb>
      <h2>Fiscal sponsorship payment</h2>
      <div className={`flex align-start ${isMobile && 'column'}`}>
        <div className="left-item" style={{ flex: '0 0 500px' }}>
          <div className="card-wrap">
            <h3>Billing cycle</h3>
            <p className="flex start align-start">
              <CheckOutlined />
              <span>
                Eligibility for grants, crowdfunding, selling tickets, corporate matching gifts, and
                other funding opportunities.
              </span>
            </p>
            <p className="flex start align-start">
              <CheckOutlined />
              <span>Tax-deductible donations of money and goods.</span>
            </p>
            <p className="flex start align-start">
              <CheckOutlined />
              <span>Free review and feedback on grant applications and fundraising materials.</span>
            </p>
            <p className="flex start align-start">
              <CheckOutlined />
              <span>All the basic Member benefits of <TheField /></span>
            </p>
            <Radio.Group
              onChange={(e) => {
                setPay({
                  ...pay,
                  priceId: e.target.value,
                  planId: price?.filter((item) => item.stripePriceId === e.target.value)[0]
                    ?.paypalPlanId
                })
              }}
              value={pay?.priceId}
            >
              {price?.map((item, index) => (
                <Radio
                  key={index}
                  value={item?.stripePriceId}
                  disabled={item.title === 'Monthly' && allowSubsidized}
                >
                  <p className={`flex disabled-${item.title === 'Monthly' && allowSubsidized}`}>
                    <i>{item.title}</i>
                    <i>
                      {item.title === 'Monthly' ? (
                        <div className={`price-warp disabled-${allowSubsidized}`}>
                          ${item?.saleAmount} per month ( $144 per year )
                        </div>
                      ) : allowSubsidized ? (
                        <div className="price-warp">
                          <div className="old-price">$110</div>&nbsp; $0 per year
                        </div>
                      ) : (
                        <>$110 per year ( You save $34 )</>
                      )}
                    </i>
                  </p>
                  <p className="text">{item.description}</p>
                </Radio>
              ))}
            </Radio.Group>
          </div>
          <div className="card-wrap">
            <h4>Payment method</h4>
            <Radio.Group
              defaultValue="credit card"
              className="radio-wrap"
              size="large"
              onChange={(e) => {
                setPay({
                  ...pay,
                  payment: e.target.value
                })
              }}
            >
              <Radio.Button value="credit card">
                <CreditCard />
                Credit card
              </Radio.Button>
              {/*<Radio.Button value="payPal">*/}
              {/*  <PayPal />*/}
              {/*  PayPal*/}
              {/*</Radio.Button>*/}
            </Radio.Group>
            {pay.payment === 'credit card' && (
              <>
                <Divider />
                <h4>Card information</h4>
                <StripePay
                  payType={payType}
                  payId={0}
                  secretId={secretId}
                  payInfo={pay}
                  ref={submitRef}
                  onNext={onSponsorPaid}
                  onFail={onPayFailed}
                />
                <Divider />
                <h4>Billing information</h4>
                <Form
                  layout="vertical"
                  size="large"
                  name="basic"
                  form={form}
                  initialValues={{ 
                    remember: true,
                    name:(userStore.info.firstName + ' ' + userStore.info.lastName).trim(),
                    email:userStore.info.email 
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  onValuesChange={(val) => {
                    setSubmitLoading(false)
                    if (val.country) {
                      form.setFieldsValue({ state: '', code:'' })
                    }
                  }}
                >
                  <Form.Item
                    label="Full Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        whitespace: false,
                        message: 'Enter full name'
                      }
                    ]}
                  >
                    <Input placeholder="Enter full name" />
                  </Form.Item>
                  <Form.Item
                    label="email address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: 'email',
                        message: 'Email'
                      }
                    ]}
                  >
                    <Input disabled={!!userStore.token} placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    label="billing address"
                    name="address"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'Address'
                      }
                    ]}
                  >
                    <Input placeholder="Address" />
                  </Form.Item>
                  <Form.Item
                    label="Country"
                    name="country"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'Choose Country'
                      }
                    ]}
                  >
                    <Select 
                      showSearch 
                      size="large" 
                      placeholder="Country"
                      optionFilterProp="label"
                      options={countryList.map((item:any) => ({
                        value:item.code,label:item.name
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    label="City"
                    name="city"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'City'
                      }
                    ]}
                  >
                    <Input placeholder="City" />
                  </Form.Item>
                  <div className={isMobile ? '' : 'flex'}>
                    <Form.Item noStyle dependencies={['country']}>
                      {({ getFieldValue }) => {
                        return getFieldValue('country') === 'US' ? (
                          <Form.Item
                            label="State"
                            name="state"
                            className="select-item"
                            rules={[
                              {
                                required: true,
                                whitespace: false,
                                message: 'Select State'
                              }
                            ]}
                          >
                            <Select showSearch size="large" placeholder="State">
                              {Object.values(stateList)?.map((item) => (
                                <Select.Option value={item} key={item}>
                                  {item}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        ) : (
                          <Form.Item
                            label="State/Province"
                            name="state"
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: 'Enter State'
                              }
                            ]}
                          >
                            <Input size="large" placeholder="State" />
                          </Form.Item>
                        )
                      }}
                    </Form.Item>
                    <Form.Item noStyle dependencies={["country"]}>
                      {({ getFieldValue }) => {
                        return getFieldValue("country") === "US" ? (
                          <Form.Item
                          label="Zip Code/Postal Code"
                          name="code"
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: 'Please enter your 5-digit zip code.',
                              validator: (_, value) => {
                                if(/(^\d{5}$)/.test(value)){
                                  return Promise.resolve()
                                }else{
                                  return Promise.reject()
                                }
                              }
                            },
                          ]}
                        >
                          <Input style={{width:'100%'}} onBeforeInput={(e:any) => {
                            if (!/^\d*$/.test(e.data)) {
                                e.preventDefault();
                            }
                            }} maxLength={5} placeholder="Zip Code" />
                        </Form.Item>
                        ) : (
                          <Form.Item
                          label="Zip Code/Postal Code"
                          name="code"
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: 'Please enter your zip code.'
                            },
                          ]}
                        >
                          <Input maxLength={10} placeholder="Zip Code" />
                        </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </div>
                  <Divider />
                  <div className="flex column start align-start">
                    <h2>
                      Contribute to Counterpart
                      <Tooltip title="Contributions to Counterpart help us serve and support independent performing artists and their companies. Thank you!">
                        <InfoCircleFilled
                          style={{ fontSize: 16, color: '#696969', marginLeft: 4 }}
                        />
                      </Tooltip>
                    </h2>
                    <Radio.Group
                      value={addon.contribution}
                      className="frequency-radio radio-wrap"
                      size="large"
                      onChange={(e) => {
                        setAddon({
                          ...addon,
                          fieldAmount: '',
                          contribution: e.target.value
                        })
                      }}
                    >
                      <Radio.Button value={false}>No, thanks</Radio.Button>
                      <Radio.Button value={true}>Yes, I’d love to</Radio.Button>
                    </Radio.Group>

                    {addon.contribution && (
                      <div className="field-form-items">
                        <span>Amount </span>
                        <Input
                          size="large"
                          placeholder="Enter amount"
                          prefix="$"
                          value={addon.fieldAmount}
                          onChange={(e) => {
                            const fieldAmount = e.target.value.replace(/[^\d\\.]+/g, '')
                            setAddon({
                              ...addon,
                              fieldAmount
                            })
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Form>
              </>
            )}
          </div>
        </div>
        <div className="right-item">
          <div className="card-wrap">
            <h3>Order summary</h3>
            <p className="flex">
              <span>Plan</span>
              Fiscal sponsorship
            </p>
            <p className="flex">
              <span>Price</span>
              <i>
                ${' '}
                <b style={{ fontSize: 16 }}>
                  {selectOption?.title === 'Annual'
                    ? allowSubsidized
                      ? 0
                      : Math.floor(Number(selectOption?.saleAmount) * 12)
                    : selectOption?.saleAmount || '--'}
                </b>
              </i>
            </p>
            <p className="flex">
              <span>Billing cycle</span>
              {selectOption?.title || '--'}
            </p>
            {selectOption?.title !== 'Once' && (
              <p className="flex">
                <span>Next billing date</span>
                {/* {selectOption?.nextBillDate || "--"} */}
                {renew
                  ? dayjs(
                      selectOption?.title === 'Annual'
                        ? renewAnnualNextBillingDate
                        : renewMonthNextBillingDate
                    ).format('MMMM DD, YYYY')
                  : selectOption?.nextBillDate || '--'}
              </p>
            )}
            {addon.fieldAmount && (
              <p className="flex">
                <span>Contribute to <TheField /></span>$
                {addon?.fieldAmount?.toLocaleString('en', {
                  style: 'currency',
                  currency: 'USD'
                })}
              </p>
            )}
            <Divider />
            {!allowSubsidized && (
              <p className="flex">
                Discount
                <b>
                  {Number(promo?.discount || 0).toLocaleString('en', {
                    style: 'currency',
                    currency: 'USD'
                  })}
                </b>
              </p>
            )}

            <p className="flex">
              Total amount
              <b>
                {/* {(
                  (selectOption?.title === "Annual"
                    ? Math.floor(Number(selectOption?.saleAmount) * 12)
                    : selectOption?.saleAmount) - promo?.discount
                ).toLocaleString("en", {
                  style: "currency",
                  currency: "USD",
                })} */}
                {Number(
                  allowSubsidized
                    ? 0
                    : amount >= 0
                    ? amount
                    : 0
                ).toLocaleString("en", {
                  style: "currency",
                  currency: "USD",
                })}
              </b>
            </p>
            <Divider />
            <div className="flex align-start" style={{ width: '100%' }}>
              <div style={{ flex: '0 0 calc(100% - 120px)' }}>
                <div className={`field-form-items ${promo?.error ? 'field-error-item' : ''}`}>
                  <span>PROMO CODE</span>
                  <Input
                    allowClear
                    placeholder="Promo code..."
                    onChange={(e) =>
                      setPromo({
                        ...promo,
                        name: e?.target.value,
                        error: false
                      })
                    }
                  />
                </div>

                <p className="error-text">
                Invalid code, please try again (codes are case-sensitive).
                </p>
              </div>
              <Button
                style={{ flex: '0 0 100px', height: '56px', marginLeft: 20 }}
                onClick={() => couponValidate(promo.name)}
              >
                Apply
              </Button>
            </div>
            <Divider />
            <p className="tips">
              By confirming this payment, you agree to our{" "}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://thefield.org/terms-of-service/"
              >
                TERMS OF SERVICE
              </a>
              {" and "}
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.thefield.org/wp-content/uploads/2024/04/The-Field-Fiscal-Sponsorship-Artist-Agreement-Blank.pdf"
              >
                SPONSORED ARTIST PROGRAM AGREEMENT.
              </a>{" "}
              To ensure continued service, we'll store and update your payment method until expiration or cancellation.
            </p>

            <Button
              type="primary"
              block
              disabled={submitLoading}
              onClick={submitPay}
            >
              confirm payment
            </Button>
          </div>
        </div>
      </div>
      <ModalInfo
        visible={show}
        onClose={() => {
          setShow(false)
          history.push('/dashboard/membership/fiscal')
        }}
        footer={[
          <Button
            onClick={() => {
              setShow(false)
              history.push('/dashboard/membership/fiscal')
            }}
          >
            later
          </Button>,
          // status === "expired" ?
          // renew ?
          //   (
          //     <Button
          //       type="primary"
          //       onClick={() => {
          //         setShow(false);
          //         history.push("/dashboard/membership/fiscal");
          //       }}
          //     >
          //       complete
          //     </Button>
          //   ) :
          <Button
            type="primary"
            onClick={() => {
              setShow(false)
              history.push('/dashboard/membership/fiscal/agreement')
            }}
          >
            Sign agreement
          </Button>
        ]}
      >
        <h4>Payment completed</h4>
        <p>
          You have successfully subscribed to <TheField/>'s Premium Membership.
          {
            renew ? ` Your new expiration date is ` :
              ` Please review and sign your contract and you can get started
          fundraising.`
          }
          {
            renew &&
            <h3>
              {dayjs(
                selectOption?.title === 'Annual'
                  ? renewAnnualNextBillingDate
                  : renewMonthNextBillingDate
              ).format('MMM DD, YYYY')}
            </h3>
          }
        </p>
      </ModalInfo>
      <ModalInfo
        visible={subsidizedShow}
        onClose={() => {
          setSubsidizedShow(false)
        }}
        footer={[
          <Button
            type="primary"
            onClick={() => {
              setSubsidizedShow(false)
            }}
          >
            OK
          </Button>
        ]}
        img={icon_donation}
      >
        <h4>First Year Subsidized</h4>
        <p>
          You are qualified for Social Justice Program. It has been automatically applied to your
          order. You won't be charged yet. Your paid plan for $110 per year will begins on{' '}
          {nextBillDate}.
        </p>
      </ModalInfo>
      {payId && (
        <Mask>
          <div className="content-wrap">
            <div className="checkout-logo">
              <img
                src="data:image/svg+xml;base64,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"
                alt=""
                aria-label="PP"
                className="paypal-logo paypal-logo-pp paypal-logo-color-white"
              />
              <img
                src="data:image/svg+xml;base64,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"
                alt=""
                aria-label="PayPal"
                className="paypal-logo paypal-logo-paypal paypal-logo-color-white"
              />
            </div>
            <span
              onClick={() => {
                setPayId('')
                _page?.close()
              }}
            >
              unpaid
            </span>
            <span onClick={checkPay}>paid</span>
          </div>
        </Mask>
      )}
    </SummaryContainer>
  )
}

export default Summary
